export default __webpack_public_path__ + "static/media/07_Amrakis.e5649c98.webp";